import React, { useContext, useEffect, useState } from 'react';
import { Button, Card, Col, Dropdown, Form, OverlayTrigger, Row, Spinner, Tooltip } from 'react-bootstrap';
import SelectOption from 'components/select/SelectOption';
import { getDrpAssetCategories, getDrpAssets, getDrpPriorities, getDrpContactTypes, getDrpCompanies, getDrpCountries, getDrpUserRoles } from '../../../../functions/dropdowns';
import { useNavigate, useParams } from 'react-router-dom';
import { addUser, getUserbyUserId } from 'functions/user';
import ProfileImageUpload from '../ProfileImageUpload';
import AssigedCompanies from 'components/companyAssignToUser/AssigedCompanies';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronCircleRight, faPlus } from '@fortawesome/free-solid-svg-icons';
import { setFieldValue } from 'helpers/validation';
import NotificationPreferences from '../notification/NotificationPreferences';
import { toastMessageBox } from 'components/ToastifyMessage';
import Toggle from 'react-toggle';
import 'react-toggle/style.css';
import AppContext from 'context/Context';

const AddUser=({})=>{
  const navigate = useNavigate();
  const { id,saveType } =  useParams();

  const _userData=JSON.parse(localStorage.getItem('userData'));

  const [isAllowedToChangePassword,setIsAllowedToChangePassword]=useState(false);

const [userName,setUserName]=useState({value:null,options:{isRequired:true,label:'Username',isValidated:true,isTouched:false,type:'string'}});
const [password,setPassword]=useState({value:null,options:{isRequired:true,label:'Password',isValidated:true,isTouched:false,type:'string'}});
const [confirmPassword,setConfirmPassword]=useState({value:null,options:{isRequired:true,label:'ConfirmPassword',isValidated:true,isTouched:false,type:'string'}});
const [contactPerson,setContactPerson]=useState({value:null,options:{isRequired:true,label:'ContactPerson',isValidated:true,isTouched:false,type:'string'}});
const [email,setEmail]=useState({value:null,options:{isRequired:true,label:'Email',isValidated:true,isTouched:false,type:'string'}});
const [telNo,setTelNo]=useState({value:null,options:{isRequired:true,label:'TelNo',isValidated:true,isTouched:false,type:'string'}});
const [mobNo,setMobNo]=useState({value:null,options:{isRequired:true,label:'MobNo',isValidated:true,isTouched:false,type:'string'}});
const [workTelNo,setWorkTelNo]=useState({value:null,options:{isRequired:true,label:'WorkTelNo',isValidated:true,isTouched:false,type:'string'}});
const [selectedCompany,setSelectedCompany]=useState({value:null,options:{isRequired:false,label:'Company',isValidated:true,isTouched:false,type:'int'}});
const [no,setNo]=useState({value:null,options:{isRequired:true,label:'No',isValidated:true,isTouched:false,type:'string'}});
const [city,setCity]=useState({value:null,options:{isRequired:true,label:'City',isValidated:true,isTouched:false,type:'string'}});
const [district,setDistrict]=useState({value:null,options:{isRequired:true,label:'District',isValidated:true,isTouched:false,type:'string'}});
const [postalCode,setPostalCode]=useState({value:null,options:{isRequired:true,label:'PostalCode',isValidated:true,isTouched:false,type:'string'}});
const [selectedCountry,setSelectedCountry]=useState({value:null,options:{isRequired:true,label:'Country',isValidated:true,isTouched:false,type:'int'}});
const [comment,setComment]=useState({value:null,options:{isRequired:true,label:'Comment',isValidated:true,isTouched:false,type:'string'}});
const [selectedRole,setSelectedRole]=useState({value:null,options:{isRequired:true,label:'Role',isValidated:true,isTouched:false,type:'int'}});
const [designation,setDesignation]=useState({value:null,options:{isRequired:true,label:'Designation',isValidated:true,isTouched:false,type:'string'}});
const [companies,setCompanies]=useState({value:[],options:{isRequired:true,label:'Companies',isValidated:true,isTouched:false}});
const [isActive, setIsActive] = useState(true);

const formFields = [
  { name: 'userName', getField: userName, setField: setUserName },
  { name: 'password', getField: password, setField: setPassword },
  { name: 'confirmPassword', getField: confirmPassword, setField: setConfirmPassword },
  { name: 'contactPerson', getField: contactPerson, setField: setContactPerson },
  { name: 'email', getField: email, setField: setEmail },
  { name: 'telNo', getField: telNo, setField: setTelNo },
  { name: 'mobNo', getField: mobNo, setField: setMobNo },
  { name: 'workTelNo', getField: workTelNo, setField: setWorkTelNo },
  { name: 'selectedCompany', getField: selectedCompany, setField: setSelectedCompany },
  { name: 'no', getField: no, setField: setNo },
  { name: 'city', getField: city, setField: setCity },
  { name: 'district', getField: district, setField: setDistrict },
  { name: 'postalCode', getField: postalCode, setField: setPostalCode },
  { name: 'selectedCountry', getField: selectedCountry, setField: setSelectedCountry },
  { name: 'comment', getField: comment, setField: setComment },
  { name: 'selectedRole', getField: selectedRole, setField: setSelectedRole },
  { name: 'designation', getField: designation, setField: setDesignation },
  { name: 'companies', getField: companies, setField: setCompanies },
  { name: 'isActive', getField: { value: isActive, options: { isRequired: false, label: 'Active', isValidated: true, isTouched: false, type: 'boolean' } }, setField: setIsActive },
];

const [userId,setUserId]=useState(null);
const [formTitle,setFormTitle]=useState(null);
const [tableId,setTableId]=useState(null);

useEffect(()=>{
  setUserId(JSON.parse(localStorage.getItem('userId')));
},[])



useEffect(()=>{

  console.log('iiii',id,saveType )
if(saveType==="I"){
  setFormTitle("Add New User");
}
else if(saveType==="U"){
  setTableId(id);
  loadUserbyUserId(id)
  setFormTitle("Edit User");
}
},[])


  const [showSubmitted,setShowSubmitted]=useState(false);
  const [isLoading,setIsLoading]=useState(false);
  const [profilePicRead,setProfilePicRead]=useState(null);

  
  const loadDrpCompanies = async () => {
    try {
      const token=localStorage.getItem('token');
      const res = await getDrpCompanies(token);
      const data = res.data;
      const options = [{ value:'', text: '-Select-' }];
      {
        data &&
          data.map(d => {
            options.push({ value: d.value, text: d.text });
          });
      }
      setCompaniesOps(options);
    } catch (err) {
      console.log('Error', err);
    }
  };

  const loadDrpCountries = async () => {
    try{
      const token=localStorage.getItem('token');
    const res = await getDrpCountries(token);
    const data = res.data;
    const options = [{ value:'', text: '-Select-' }];
    {
      data &&
        data.map(d => {
          options.push({ value: d.value, text: d.text });
        });
    }
    setCountriesOps(options);
  }
  catch(err){
    console.log('Error',err);
  }
  };

  const loadDrpUserRoles = async () => {
    try{
      const token=localStorage.getItem('token');
    const res = await getDrpUserRoles(token);
    const data = res.data;
    const options = [{ value:'', text: '-Select-' }];
    {
      data &&
        data.map(d => {
          options.push({ value: d.value, text: d.text });
        });
    }
    setRolesOps(options);
  }
  catch(err){
    console.log('Error',err);
  }
  };

  const loadUserbyUserId = async (id) => {
    try{
      const token=localStorage.getItem('token');
    const res = await getUserbyUserId(id,token);
   
    const {UserName,ContactPerson,No,City,District,PostalCode,TelNo,MobNo,WorkTel,
      Comment,Email,Designation,ProfilePic,CountryId,RoleId,Password, IsActive} = res.user;

      const {assignedCompanies}=res;

      console.log('load users AssigedCompanies',res);
      setUserName({ ...userName, value: UserName });
      setPassword({...password,value:Password});
      setConfirmPassword({...confirmPassword,value:Password});
      setContactPerson({ ...contactPerson, value: ContactPerson });
      setNo({ ...no, value: No });
      setCity({ ...city, value: City });
      setDistrict({ ...district, value: District });
      setPostalCode({ ...postalCode, value: PostalCode });
      setSelectedCountry({ ...selectedCountry, value: CountryId });
      setTelNo({ ...telNo, value: TelNo });
      setMobNo({ ...mobNo, value: MobNo });
      setWorkTelNo({ ...workTelNo, value: WorkTel });
      setComment({ ...comment, value: Comment });
      setEmail({ ...email, value: Email });
     // setSelectedCompany({ ...selectedCompany, value: CompanyMasterId });
      setSelectedRole({ ...selectedRole, value: RoleId });
      setDesignation({ ...designation, value: Designation });
      setCompanies({ ...companies, value: assignedCompanies });
      setIsActive(IsActive);

      setProfilePicRead(ProfilePic);
      //setAttachments([{ id: 1, name: '', size:null, type: 'image/jpg',fileNo:ProfilePic,file:null }])

  }
  catch(err){
    console.log('Error',err);
  }
  };


  

  useEffect(() => {
    loadDrpCompanies();
    loadDrpCountries();
    loadDrpUserRoles();
  }, []);

  useEffect(() => {
    if(isAllowedToChangePassword){ 
    setPassword({...password,value:''});
    setConfirmPassword({...confirmPassword,value:''});
    }
    else{
      setPassword({...password,value:'**********'});
      setConfirmPassword({...confirmPassword,value:'**********'});
    }
  }, [isAllowedToChangePassword]);


  const [companiesOps,setCompaniesOps]=useState(null);        
  const [countriesops,setCountriesOps]=useState(null);
  const [rolesOps,setRolesOps]=useState(null);

  const [iud,setIud]=useState("I");


const closeSubmittedPanel=()=>{
setShowSubmitted(false);
}
  const onSubmitData = async event => {
    event.preventDefault();

    try {
      setIsLoading(true);

      let inValidCount = 0;
      // setAttachments([]);
      formFields.map(f => {
        // Only validate fields that have options (skip isActive and similar fields)
        if (f.getField && f.getField.options) {
          const isValidated = setFieldValue(f.getField.value, f.name, formFields);
          if (!isValidated) {
            inValidCount += 1;
          }
        }
      });

      if (inValidCount > 0) {
        setIsLoading(false);
        return;
      }
      setShowSubmitted(true);



      if(password.value!==confirmPassword.value){
        toastMessageBox('Exception', "Confirm password doen't match", 'danger');
        setIsLoading(false);
        return;
      }

      //const fileUploadObjs=[];

      // Array.from(attachments).forEach(attachment => {
      //   fileUploadObjs.push({fileNo:attachment.fileNo,size:attachment.size,type:attachment.type,name:attachment.name});
      // });

      // console.log('fileUploadObjs-----', fileUploadObjs);

      const data = {
        userRegId: tableId,
        userName: userName.value,
        password: password.value,
        confirmPassword: confirmPassword.value,
        contactPerson: contactPerson.value,
        email: email.value,
        designation:designation.value,
        telNo: telNo.value,
        mobNo: mobNo.value,
        workTel: workTelNo.value,
        companies: companies.value,
        no: no.value,
        city: city.value,
        district: district.value,
        postalCode: postalCode.value,
        country: selectedCountry.value,
        comment: comment.value,
        profilePic:attachments.length!==0 ? attachments[0].fileNo:null,
        iud: saveType,
        isActive: isActive, // <-- use the current state
        userRoleId:selectedRole.value,
        isAllowedToChangePassword,
        gmtOffset: new Date().getTimezoneOffset().toString(), // Add gmtOffset as required by backend
      };
      console.log('date to submit data', data);
      const token = localStorage.getItem('token');
      const res = await addUser(data, token);
      console.log('date to submit', res.data);

      // Defensive check for backend response structure
      if (!res.data || !res.data.output) {
        toastMessageBox('Exception', 'Unexpected server response. Please try again.', 'danger');
        setIsLoading(false);
        return;
      }
      const { responseStatus, outputMessage } = res.data.output;

      if (responseStatus === 'failed') {
        toastMessageBox('Exception', outputMessage, 'danger');
        // navigate('/support-desk/list-users');
        setIsLoading(false);
        return;
      }

      toastMessageBox('Success', outputMessage, 'success');
   
      if(_userData.roleId!==2 && _userData.roleId!==4){
        navigate('/support-desk/list-users');
      }

      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      console.log('Error:', err);
    }
  };



const setAttachmentHandler=(attachments)=>{

  setAttachments(attachments);
}
const [attachments, setAttachments] = useState([
  // { id: 1, name: 'winter.jpg', size: 893952, type: 'image/jpg',fileNo:1,file:null },
  // { id: 2, name: 'coffee.zip', size: 350208, type: 'application/zip',fileNo:2,file:null }
]);
//const companies=[{title:"ABASN",id:1},{title:"ABASN2",id:2}]
 // const [data,setData]=useState(companies);
  const setCompaniesHandler=(obj)=>{
    
    setCompanies({ ...companies, value: obj });
  }

const companyAddHandler=()=>{
 
  console.log('selectedCompany.value',selectedCompany.value)
  if(selectedCompany.value===null || selectedCompany.value.trim().length===0){
    toastMessageBox('Exception', "Select a company to assign", 'danger');
    return;
  }


  const existingCompany=companies.value.filter(c=>c.companyId==selectedCompany.value);
  if(existingCompany.length>0)
  return;

const compObj=companiesOps.filter(c=>c.value==selectedCompany.value);
const companyName=compObj[0].text;

  const existingObjs=[...companies.value,{companyId:selectedCompany.value,companyName}]

      setCompanies({ ...companies, value: existingObjs });
      setFieldValue('', 'selectedCompany',formFields);
}



const { config } = useContext(AppContext);
const { isDark } = config;
const textColor = isDark ? '#fff' : '#212529';

const ticketForm=()=>{
 return (
   <Card className="mb-3">
     <Card.Header className="bg-light" style={{ color: textColor, background: isDark ? '#23272b' : undefined }}>
       <h4 className="mb-0" style={{ color: textColor }}>{formTitle}</h4>
     </Card.Header>
     <Card.Body className="bg-light" style={{ color: textColor, background: isDark ? '#23272b' : undefined }}>
       <style>{`
         .add-user-label { color: ${textColor} !important; }
       `}</style>
       <Row className="gx-2 gy-3 mb-5">
         <Col md="auto" className="text-center">
           <ProfileImageUpload
             imgSrc={profilePicRead}
             setAttachmentHandler={setAttachmentHandler}
           />
         </Col>
         {/* {JSON.stringify(attachments.length!==0 ? `${API}/file/image/${attachments[0].fileNo} ` : null)} */}
       </Row>

       <h5>User Account Details</h5>
       <hr />
       <Row className="gx-2 gy-3">
         <Col sm="3">
           <Form.Group
             as={Row}
             className="mb-3"
             controlId="formPlaintextSubject"
           >
             <Form.Label sm="12" className="add-user-label">
               User Name
               {userName.options.isRequired && (
                 <span className="text-danger">*</span>
               )}
             </Form.Label>
             <Col sm="12">
               <Form.Control
                 type="text"
                 disabled={_userData.roleId === 2 || _userData.roleId === 4}
                 placeholder=""
                 onChange={e => {
                   setFieldValue(e.target.value, 'userName',formFields);
                 }}
                 value={userName.value}
               />
               {!userName.options.isValidated && userName.options.isTouched && (
                 <p
                   className="text-danger"
                   style={{ marginLeft: '10px' }}
                 >{`${userName.options.label} is required`}</p>
               )}
             </Col>
           </Form.Group>
         </Col>
  
   
             
         <Col sm="3">
       
           <Form.Group
             as={Row}
             className="mb-3"
             controlId="formPlaintextSubject"
           >
             <Form.Label sm="12" className="add-user-label">
               Password
               {password.options.isRequired && (
                 <span className="text-danger">*</span>
               )}
             </Form.Label>
             <Col sm="12">
               <Form.Control
                 type="password"
                 disabled={!isAllowedToChangePassword}
                 placeholder=""
                 onChange={e => {
                   setFieldValue(e.target.value, 'password',formFields);
                 }}
                 value={password.value}
               />
               {!password.options.isValidated && password.options.isTouched && (
                 <p
                   className="text-danger"
                   style={{ marginLeft: '10px' }}
                 >{`${password.options.label} is required`}</p>
               )}
             </Col>
           </Form.Group>
         </Col>


         <Col sm="3">
           <Form.Group
             as={Row}
             className="mb-3"
             controlId="formPlaintextSubject"
           >
             <Form.Label sm="12" className="add-user-label">
               Confirm Password
               {confirmPassword.options.isRequired && (
                 <span className="text-danger">*</span>
               )}
             </Form.Label>
             <Col sm="12">
               <Form.Control
                 type="password"
                 placeholder=""
                 disabled={!isAllowedToChangePassword}
                 onChange={e => {
                   setFieldValue(e.target.value, 'confirmPassword',formFields);
                 }}
                 value={confirmPassword.value}
               />
               {!confirmPassword.options.isValidated &&
                 confirmPassword.options.isTouched && (
                   <p
                     className="text-danger"
                     style={{ marginLeft: '10px' }}
                   >{`${confirmPassword.options.label} is required`}</p>
                 )}
             </Col>
           </Form.Group>
         </Col>
    
         <Col sm="3">

    <Form.Check id="full-refund" className="mb-0 form-check">
      <Form.Check.Input
        className="mb-0"
        type="checkbox"
        value={isAllowedToChangePassword}
        onChange={(e)=>{
          setIsAllowedToChangePassword(!isAllowedToChangePassword);
        }}
      />
      <Form.Check.Label className="mb-0">Allow change password</Form.Check.Label>
    </Form.Check>

</Col>
       </Row>


       <Row className="gx-2 gy-3">
         <Col sm="4">
           <Form.Group
             as={Row}
             className="mb-3"
             controlId="formPlaintextSubject"
           >
             <Form.Label sm="12" className="add-user-label">
               Display Name
               {contactPerson.options.isRequired && (
                 <span className="text-danger">*</span>
               )}
             </Form.Label>
             <Col sm="12">
               <Form.Control
                 type="text"
                 placeholder=""
                 onChange={e => {
                   setFieldValue(e.target.value, 'contactPerson',formFields);
                 }}
                 value={contactPerson.value}
               />
               {!contactPerson.options.isValidated &&
                 contactPerson.options.isTouched && (
                   <p
                     className="text-danger"
                     style={{ marginLeft: '10px' }}
                   >{`${contactPerson.options.label} is required`}</p>
                 )}
             </Col>
           </Form.Group>
         </Col>

         <Col sm="4">
           <Form.Group
             as={Row}
             className="mb-3"
             controlId="formPlaintextSubject"
           >
             <Form.Label sm="12" className="add-user-label">
               Role
               {selectedRole.options.isRequired && (
                 <span className="text-danger">*</span>
               )}
             </Form.Label>
             <Col sm="12">
               <SelectOption
                 options={rolesOps}
                 disabled={_userData.roleId === 2 || _userData.roleId === 4}
                 handleChange={e => {
                   setFieldValue(e.target.value, 'selectedRole',formFields);
                 }}
                 selectedValue={selectedRole.value}
               />
               {!selectedRole.options.isValidated &&
                 selectedRole.options.isTouched && (
                   <p
                     className="text-danger"
                     style={{ marginLeft: '10px' }}
                   >{`${selectedRole.options.label} is required`}</p>
                 )}
             </Col>
           </Form.Group>
         </Col>
         <Col sm="4">
           <Form.Group
             as={Row}
             className="mb-3"
             controlId="formPlaintextSubject"
           >
             <Form.Label sm="12" className="add-user-label">
               Designation
               {designation.options.isRequired && (
                 <span className="text-danger">*</span>
               )}
             </Form.Label>
             <Col sm="12">
               <Form.Control
                 type="text"
                 placeholder=""
                 onChange={e => {
                   setFieldValue(e.target.value, 'designation',formFields);
                 }}
                 value={designation.value}
               />
               {!designation.options.isValidated &&
                 designation.options.isTouched && (
                   <p
                     className="text-danger"
                     style={{ marginLeft: '10px' }}
                   >{`${designation.options.label} is required`}</p>
                 )}
             </Col>
           </Form.Group>
         </Col>
       </Row>
       <br />
       <h5>Contact Details</h5>
       <hr />
       <Row className="gx-2 gy-3">
         <Col sm="4">
           <Form.Group
             as={Row}
             className="mb-3"
             controlId="formPlaintextSubject"
           >
             <Form.Label sm="12" className="add-user-label">
               Tel No
               {telNo.options.isRequired && (
                 <span className="text-danger">*</span>
               )}
             </Form.Label>
             <Col sm="12">
               <Form.Control
                 type="text"
                 placeholder=""
                 onChange={e => {
                   setFieldValue(e.target.value, 'telNo',formFields);
                 }}
                 value={telNo.value}
               />
               {!telNo.options.isValidated && telNo.options.isTouched && (
                 <p
                   className="text-danger"
                   style={{ marginLeft: '10px' }}
                 >{`${telNo.options.label} is required`}</p>
               )}
             </Col>
           </Form.Group>
         </Col>

         <Col sm="4">
           <Form.Group
             as={Row}
             className="mb-3"
             controlId="formPlaintextSubject"
           >
             <Form.Label sm="12" className="add-user-label">
               Mob. No
               {mobNo.options.isRequired && (
                 <span className="text-danger">*</span>
               )}
             </Form.Label>
             <Col sm="12">
               <Form.Control
                 type="text"
                 placeholder=""
                 onChange={e => {
                   setFieldValue(e.target.value, 'mobNo',formFields);
                 }}
                 value={mobNo.value}
               />
               {!mobNo.options.isValidated && mobNo.options.isTouched && (
                 <p
                   className="text-danger"
                   style={{ marginLeft: '10px' }}
                 >{`${mobNo.options.label} is required`}</p>
               )}
             </Col>
           </Form.Group>
         </Col>

         <Col sm="4">
           <Form.Group
             as={Row}
             className="mb-3"
             controlId="formPlaintextSubject"
           >
             <Form.Label sm="12" className="add-user-label">
               Work Tel. No
               {workTelNo.options.isRequired && (
                 <span className="text-danger">*</span>
               )}
             </Form.Label>
             <Col sm="12">
               <Form.Control
                 type="text"
                 placeholder=""
                 onChange={e => {
                   setFieldValue(e.target.value, 'workTelNo',formFields);
                 }}
                 value={workTelNo.value}
               />
               {!workTelNo.options.isValidated &&
                 workTelNo.options.isTouched && (
                   <p
                     className="text-danger"
                     style={{ marginLeft: '10px' }}
                   >{`${workTelNo.options.label} is required`}</p>
                 )}
             </Col>
           </Form.Group>
         </Col>
       </Row>

       <Row className="gx-2 gy-3">
         <Col sm="4">
           <Form.Group
             as={Row}
             className="mb-3"
             controlId="formPlaintextSubject"
           >
             <Form.Label sm="12" className="add-user-label">
               Email
               {email.options.isRequired && (
                 <span className="text-danger">*</span>
               )}
             </Form.Label>
             <Col sm="12">
               <Form.Control
                 disabled={_userData.roleId === 2 || _userData.roleId === 4}
                 type="text"
                 placeholder=""
                 onChange={e => {
                   setFieldValue(e.target.value, 'email',formFields);
                 }}
                 value={email.value}
               />
               {!email.options.isValidated && email.options.isTouched && (
                 <p
                   className="text-danger"
                   style={{ marginLeft: '10px' }}
                 >{`${email.options.label} is required`}</p>
               )}
             </Col>
           </Form.Group>
         </Col>

         <Col sm="4">
           <Form.Group
             as={Row}
             className="mb-3"
             controlId="formPlaintextSubject"
           >
             <Form.Label sm="12" className="add-user-label">
               No.
               {no.options.isRequired && <span className="text-danger">*</span>}
             </Form.Label>
             <Col sm="12">
               <Form.Control
                 type="text"
                 placeholder=""
                 onChange={e => {
                   setFieldValue(e.target.value, 'no',formFields);
                 }}
                 value={no.value}
               />
               {!no.options.isValidated && no.options.isTouched && (
                 <p
                   className="text-danger"
                   style={{ marginLeft: '10px' }}
                 >{`${no.options.label} is required`}</p>
               )}
             </Col>
           </Form.Group>
         </Col>

         <Col sm="4">
           <Form.Group
             as={Row}
             className="mb-3"
             controlId="formPlaintextSubject"
           >
             <Form.Label sm="12" className="add-user-label">
               City
               {city.options.isRequired && (
                 <span className="text-danger">*</span>
               )}
             </Form.Label>
             <Col sm="12">
               <Form.Control
                 type="text"
                 placeholder=""
                 onChange={e => {
                   setFieldValue(e.target.value, 'city',formFields);
                 }}
                 value={city.value}
               />
               {!city.options.isValidated && city.options.isTouched && (
                 <p
                   className="text-danger"
                   style={{ marginLeft: '10px' }}
                 >{`${city.options.label} is required`}</p>
               )}
             </Col>
           </Form.Group>
         </Col>
       </Row>

       <Row className="gx-2 gy-3">
         <Col sm="4">
           <Form.Group
             as={Row}
             className="mb-3"
             controlId="formPlaintextSubject"
           >
             <Form.Label sm="12" className="add-user-label">
               Postal Code
               {postalCode.options.isRequired && (
                 <span className="text-danger">*</span>
               )}
             </Form.Label>
             <Col sm="12">
               <Form.Control
                 type="text"
                 placeholder=""
                 onChange={e => {
                   setFieldValue(e.target.value, 'postalCode',formFields);
                 }}
                 value={postalCode.value}
               />
               {!postalCode.options.isValidated &&
                 postalCode.options.isTouched && (
                   <p
                     className="text-danger"
                     style={{ marginLeft: '10px' }}
                   >{`${postalCode.options.label} is required`}</p>
                 )}
             </Col>
           </Form.Group>
         </Col>
         <Col sm="4">
           <Form.Group
             as={Row}
             className="mb-3"
             controlId="formPlaintextSubject"
           >
             <Form.Label sm="12" className="add-user-label">
               District
               {district.options.isRequired && (
                 <span className="text-danger">*</span>
               )}
             </Form.Label>
             <Col sm="12">
               <Form.Control
                 type="text"
                 placeholder=""
                 onChange={e => {
                   setFieldValue(e.target.value, 'district',formFields);
                 }}
                 value={district.value}
               />
               {!district.options.isValidated && district.options.isTouched && (
                 <p
                   className="text-danger"
                   style={{ marginLeft: '10px' }}
                 >{`${district.options.label} is required`}</p>
               )}
             </Col>
           </Form.Group>
         </Col>
         <Col sm="4">
           <Form.Group
             as={Row}
             className="mb-3"
             controlId="formPlaintextSubject"
           >
             <Form.Label sm="12" className="add-user-label">
               Country
               {selectedCountry.options.isRequired && (
                 <span className="text-danger">*</span>
               )}
             </Form.Label>
             <Col sm="12">
               <SelectOption
                 options={countriesops}
                 handleChange={e => {
                   setFieldValue(e.target.value, 'selectedCountry',formFields);
                 }}
                 selectedValue={selectedCountry.value}
               />
               {!selectedCountry.options.isValidated &&
                 selectedCountry.options.isTouched && (
                   <p
                     className="text-danger"
                     style={{ marginLeft: '10px' }}
                   >{`${selectedCountry.options.label} is required`}</p>
                 )}
             </Col>
           </Form.Group>
         </Col>
       </Row>

       <Row className="gx-2 gy-3">
         <Col sm="8">
           <Form.Group
             as={Row}
             className="mb-3"
             controlId="formPlaintextSubject"
           >
             <Form.Label sm="12" className="add-user-label">
               Comment
               {comment.options.isRequired && (
                 <span className="text-danger">*</span>
               )}
             </Form.Label>
             <Col sm="12">
               <Form.Control
                 as="textarea"
                 onChange={e => {
                   setFieldValue(e.target.value, 'comment',formFields);
                 }}
                 value={comment.value}
                 rows={3}
               />
               {!comment.options.isValidated && comment.options.isTouched && (
                 <p
                   className="text-danger"
                   style={{ marginLeft: '10px' }}
                 >{`${comment.options.label} is required`}</p>
               )}
             </Col>
           </Form.Group>
         </Col>
       </Row>

       {_userData.roleId !== 2 && _userData.roleId !== 4 && (
         <>
           <br />
           <h5>Company Assignment</h5>
           <hr />
           <Row className="gx-2 gy-3">
             <Col sm="4">
               <Form.Group
                 as={Row}
                 className="mb-3"
                 controlId="formPlaintextPriority"
               >
                 <Form.Label sm="12" className="add-user-label">
                   Company <span className="text-danger">*</span>
                 </Form.Label>
                 <Col sm="12">
                   <SelectOption
                     options={companiesOps ? companiesOps.filter(op => 
                       op.value === '' || !companies.value.some(c => c.companyId == op.value)
                     ) : []}
                     handleChange={e => {
                       setFieldValue(e.target.value, 'selectedCompany',formFields);
                     }}
                     selectedValue={selectedCompany.value}
                   />
                   {!selectedCompany.options.isValidated &&
                     selectedCompany.options.isTouched && (
                       <p
                         className="text-danger"
                         style={{ marginLeft: '10px' }}
                       >{`${selectedCompany.options.label} is required`}</p>
                     )}
                 </Col>
               </Form.Group>
             </Col>
             <Col
               sm="4"
               className="d-flex align-items-center justify-content-center"
             >
               <Button
                 variant="falcon-default"
                 className="rounded-pill me-2 mb-1"
                 onClick={companyAddHandler}
               >
                 Add
                 <FontAwesomeIcon
                   icon={faChevronCircleRight}
                   className="text-secondary ms-1"
                   style={{ cursor: 'pointer' }}
                 />
               </Button>
             </Col>
             <Col sm="4">
               <AssigedCompanies
                 data={companies.value}
                 setData={setCompaniesHandler}
               />
             </Col>
           </Row>
         </>
       )}

       <Row className="gx-2 gy-3">
         <Col sm="3">
           <Form.Group as={Row} className="mb-3" controlId="formPlaintextActive">
             <Form.Label sm="12" className="add-user-label">
               Availability Status
             </Form.Label>
             <Col sm="12" className="d-flex align-items-center">
               <Button
                 variant={isActive ? "success" : "secondary"}
                 onClick={() => setIsActive(!isActive)}
                 className="me-2"
               >
                 {isActive ? "Active" : "Inactive"}
               </Button>
               <span>{isActive ? "User is Active" : "User is Inactive"}</span>
             </Col>
           </Form.Group>
         </Col>
         {/* ...existing code... */}
       </Row>

       <Row>
         <Col xs="12">
           <div className="text-center" style={{ marginTop: '40px' }}>
             <Button
               variant="success"
               size="lg"
               className="me-2 mb-1"
               onClick={onSubmitData}
               disabled={isLoading}
             >
               {isLoading ? (
                 <>
                   {' '}
                   <Spinner
                     as="span"
                     animation="grow"
                     size="sm"
                     role="status"
                     aria-hidden="true"
                   />{' '}
                   Saving...
                 </>
               ) : (
                 'Save'
               )}
             </Button>
           </div>
         </Col>
       </Row>
       <br />
       <NotificationPreferences selectedUserId={id} />
     </Card.Body>
   </Card>
 );
}
      return <>{ticketForm()}</>;
   

}

export default AddUser;